import React from 'react';

import GlobalStyles from './assets/styles/global';
import Welcome from './pages/Welcome';

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Welcome />
    </>
  );
}
